var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
		'pdp-content-boxes',
		'box',
		{ 'pdp-content-boxes-shadow': _vm.enableShadow },
		{ 'pdp-content-boxes-animation': _vm.enableAnimation }
	]},[_c('div',{staticClass:"col sm-auto"},[_c('ContentBox',{attrs:{"boxData":_vm.box1Data},on:{"button-click":_vm.onButtonOneClicked}})],1),_vm._v(" "),_c('div',{staticClass:"col sm-auto"},[_c('ContentBox',{attrs:{"boxData":_vm.box2Data},on:{"button-click":_vm.onButtonTwoClicked}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }